export class EmpSkillMatrixReq {
    employeeId?: number;
    employeeName?:string
    plant?:string
}